export default __webpack_public_path__ + "static/media/templateImage.39cbc096.png";